<template>
    <div class="calculator">
        <h1>Calculateur</h1>
        <div class="form">
            <div :class="{ select:isDistFixed }">
                <div class="wrap-elmt">
                  <label for="distInput" class="form-label" @click="distClick"><font-awesome-icon icon="fa-solid fa-road" />Distance</label>
                  <input type="text" class="form-control" id="distInput" :disabled="isDistFixed" :value="distValue" @input="distValue = $event.target.value">
                </div>
                <div class="wrap-preset" v-show="!isDistFixed">
                  <p class="preset" @click="distValue=42.195">Marathon</p>
                  <p class="preset" @click="distValue=21.1">Semi</p>
                  <p class="preset" @click="distValue=10">10k</p>
                </div>
            </div>
            <div :class="{ select:isTimeFixed }">
              <div class="wrap-elmt">
                <label for="timeInput" class="form-label" @click="timeClick"><font-awesome-icon icon="fa-solid fa-gauge-high" />Chrono</label>
                <input type="text" class="form-control" id="timeInput" :disabled="isTimeFixed" :value="timeValue" @input="timeValue = $event.target.value">
                <p class="icon-calc">
                  <Popper :content="timeInSeconds()" hover="true" placement="top">
                    <font-awesome-icon icon="fa-solid fa-calculator" />
                  </Popper>
                </p>
              </div>
                <div class="wrap-preset" v-show="!isTimeFixed">
                  <p class="preset" @click="timeValue='4:00:00'">4h</p>
                  <p class="preset" @click="timeValue='2:00:00'">2h</p>
                  <p class="preset" @click="timeValue='1:00:00'">1h</p>
                </div>
            </div>
            <div :class="{ select:isPaceFixed }">
              <div class="wrap-elmt">
                <label for="allureInput" class="form-label" @click="paceClick"><font-awesome-icon icon="fa-solid fa-gauge-high" />Allure</label>
                <input type="text" class="form-control" id="allureInput" :disabled="isPaceFixed" :value="paceValue" @input="paceValue = $event.target.value">
              </div>
            </div>
        </div>
    </div>
</template>

  <script>

  import Popper from "vue3-popper";
  import { library } from '@fortawesome/fontawesome-svg-core'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faGaugeHigh, faStopwatch, faRoad, faUserAstronaut, faCalculator } from '@fortawesome/free-solid-svg-icons'

  library.add(faGaugeHigh, faStopwatch, faRoad, faUserAstronaut, faCalculator)


  export default {
    name: 'CalculatorComponent',
    components: {
      FontAwesomeIcon,
      Popper
    }, data: function() {
        return {
            isDistFixed: false,
            isTimeFixed: false,
            isPaceFixed: true,
            distValue: 21.1,
            timeValue: "02:00:00",
            paceValue: "05:41",
            dist: 21.1,
            time: [2,0,0],
            pace: [0,5,41]
        }
    }, watch: {
      distValue() {
        let pattern = /^[0-9]*\.?[0-9]*$/
        let result=pattern.test(this.distValue)
        if(result) {
          this.dist = this.distValue*1
          this.calc()
        }
      }, timeValue() {
        let pattern = /^[0-9]{0,2}(:[0-9]{0,2})?(:[0-9]{0,2})?$/
        let result=pattern.test(this.timeValue)
        if(result && this.timeValue.length > 0) {
          let val=this.timeValue.split(":")
          let h = val[0]*1
          let m = 0
          let s = 0;
          if(val.length>1) m = val[1]*1
          if(val.length>2) s = val[2]*1
          this.time = [h, m, s]
          this.calc()
        }
      }, paceValue() {
        let pattern = /^[0-9]{0,2}(:[0-9]{0,2})?(:[0-9]{0,2})?$/
        let result=pattern.test(this.paceValue)
        if(result && this.paceValue.length > 0) {
          let val=this.paceValue.split(":")
          if(val.length==1) {
            this.pace = [0, val[0]*1, 0]
          } else if(val.length==2) {
            this.pace = [0, val[0]*1, val[1]*1]
          } else {
            this.pace = [val[0]*1, val[1]*1, val[2]*1]
          }
          this.calc()
        }
      }
    }, methods: {
      calc() {
        if(this.isPaceFixed) {
          let minutes = this.time[0]*60+this.time[1]+this.time[2]/60
          let pace = minutes/this.dist
          let h = Math.floor(pace/60)
          let m = Math.floor(pace-h*60)
          let s = Math.floor(pace*60-h*3600-m*60)
          this.pace = [h, m, s]
          let k = ""
          if(h>0) k += h+":"
          if(m<10) k += "0"
          k += m+":"
          if(s<10) k += "0"
          k += s
          this.paceValue = k
        } else if(this.isDistFixed) {
          let m = this.time[0]*60+this.time[1]+this.time[2]/60
          let p = this.pace[0]*60+this.pace[1]+this.pace[2]/60
          this.dist = Math.floor(m/p*100)/100
          this.distValue = this.dist
        } else if(this.isTimeFixed) {
          let p = this.pace[0]*60+this.pace[1]+this.pace[2]/60
          let t = p*this.dist
          let h = Math.floor(t/60)
          let m = Math.floor(t-h*60)
          let s = Math.floor(t*60-h*3600-m*60)
          this.time = [h, m, s]
          let k = ""
          if(h>0) k += h+":"
          if(m<10) k += "0"
          k += m+":"
          if(s<10) k += "0"
          k += s
          this.timeValue = k
        }
      }, distClick() {
        this.isDistFixed = true
        this.isTimeFixed = false
        this.isPaceFixed = false
      }, timeClick() {
        this.isDistFixed = false
        this.isTimeFixed = true
        this.isPaceFixed = false
      }, paceClick() {
        this.isDistFixed = false
        this.isTimeFixed = false
        this.isPaceFixed = true
      }, timeInSeconds() {
        return this.time[0]*3600+this.time[1]*60+this.time[2]
      }
    }
  }
  </script>
  <style scoped>

  :deep(.popper) {
    background: #FFECA1;
    padding: 3px 7px;
    border-radius: 5px;
    color: #250B40;
    text-transform: uppercase;
  }

  .calculator {
    background-color: #250B40;
    color: #FFECA1;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form {
    margin-top: 100px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 50px;
    font-family: 'Montserrat Alternates', sans-serif;
  }

  .form>div {
    width: 250px;
    display: flex;
    flex-flow: column;
    gap: 20px;
    align-items: flex-end;
  }

  .wrap-elmt {
    display: flex;
    flex-flow: row;
    border-radius: 5px;
    padding: 7px;
    padding-left: 10px;
  }

  .wrap-preset {
      display: flex;
      gap: 12px;
      justify-content: space-around;
      width: 250px;
  }

  .preset {
    font-size: 0.8em;
    color: red;
    background-color: #BFA688;
    color: #250B40;
    padding: 5px;
    border-radius: 8px;
    min-width: 50px;
    cursor: pointer;
  }

  .preset:hover {
    font-weight: bold;
  }

  h1 {
    margin-top: 50px;
  }

  label {
    cursor: pointer;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .select .wrap-elmt{
    background-color: #BFA688;
    color: #250B40;
  }
  .select input[type=text] {
    background-color: #BFA688;
    color: #250B40;
    border: none;
  }

  input[type=text] {
    background-color: #250B40;
    border: none;
    border-bottom: solid 2px #FFECA1;
    outline: none;
    color: #FFECA1;
    border-radius: 0px;
    text-align: center;
  }

  a, a:active, a:focus {
    font-family: 'Montserrat Alternates', sans-serif;
    padding: 5px;
    border-radius: 5px;
    color: #FFECA1;
    text-decoration: none;
    font-size: 1.5em;
    margin-top: 100px;
    transition: 1s all;
  }

  a:hover {
    background-color: #BFA688;
    color: #250B40;
  }

  .icon-calc {
    height: 14px;
    align-self: end;
    margin-left: 10px;
    cursor: pointer;
  }

  </style>
